import { delay } from './delay';

/**
 *
 * @return {(function(callback, duration): void)|*}
 */
export const hold = () => {
  const start = Date.now();

  function holder(callback, duration) {
    const end = Date.now();
    if (end - start < duration) {
      delay(() => {
        callback();
      }, duration - (end - start));
    } else {
      callback();
    }
  }

  holder.start = start;
  holder.getTime = () => Date.now() - start;
  return holder;
};
